import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatBytes(
  bytes: number,
  opts: {
    decimals?: number;
    sizeType?: "accurate" | "normal";
  } = {},
) {
  const { decimals = 0, sizeType = "normal" } = opts;

  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const accurateSizes = ["Bytes", "KiB", "MiB", "GiB", "TiB"];
  if (bytes === 0) return "0 Byte";
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(decimals)} ${
    sizeType === "accurate" ? (accurateSizes[i] ?? "Bytest") : (sizes[i] ?? "Bytes")
  }`;
}

/**
 * 휴대폰 번호 마스킹: 1238012380123 → 1238012****23
 * 중간 4자리를 * 처리
 */
export function maskPhoneNumber(phone: string): string {
  if (!phone) return phone;
  if (phone.length <= 6) return phone; // 너무 짧으면 마스킹 안 함
  const start = phone.slice(0, -6);
  const end = phone.slice(-2);
  return `${start}****${end}`;
}

/**
 * 이메일 마스킹: admin@example.com → ad***@example.com
 * @앞 3자리 마스킹
 */
export function maskEmail(email: string): string {
  if (!email || !email.includes("@")) return email;
  const [local, domain] = email.split("@");
  if (local.length <= 3) return email; // 3자리 이하는 마스킹 안 함
  const start = local.slice(0, -3);
  return `${start}***@${domain}`;
}

/**
 * 이름 마스킹
 * - 단일 이름: Thomas → T****
 * - 복수 이름: Thomas Butter CCC → Thomas B**** C**
 */
export function maskName(name: string): string {
  if (!name) return name;
  const parts = name.trim().split(/\s+/);

  if (parts.length === 1) {
    // 단일 이름: 첫글자만 표시
    const part = parts[0];
    return part.length <= 1 ? part : part[0] + "*".repeat(part.length - 1);
  }

  // 복수 이름: 첫번째는 전체, 나머지는 첫글자만
  return parts
    .map((part, index) => {
      if (index === 0) return part; // 첫번째 이름 전체 표시
      return part.length <= 1 ? part : part[0] + "*".repeat(part.length - 1);
    })
    .join(" ");
}
